import { CSSProperties } from 'react';

import cn from './Component.module.scss';

export const Seperator = ({ background }: { background: CSSProperties['background'] }) => {
  return (
    <div className={cn.separator}>
      <div style={{ background }} />
    </div>
  );
};
